module.exports = __webpack_public_path__ + "static/img/music_quiz_title.d57d808.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/music_quiz/music_quiz_title.png
// module id = yfrm
// module chunks = 1